import { connect } from 'react-redux'
import { change } from 'redux-form'
import { push } from 'react-router-redux'

import {
  createLead,
  createLeadSuccess,
} from '../../../actions/leadActionCreators'
import { geocodeAddress } from '../../../actions/geocodeActionCreators'
import { fetchPositionsAndRedirect } from '../../../actions/positionActionCreators'

const activeYears = process.env.REACT_APP_ACTIVE_ELECTION_YEARS
const futureYears = process.env.REACT_APP_FUTURE_ELECTION_YEARS
const skipLeadCreate = process.env.REACT_APP_SKIP_HOME_LEAD_CREATE === '1'

const mapStateToProps = (state, ownProps) => ({
  busy: state.busy,
  initialValues: ownProps,
  ready: state.latLng.lat,
  years: activeYears
    .split(',')
    .concat(futureYears.split(','))
    .filter(n => n),
  appConfig: state.appConfig,
  errorMessage: state.leadError,
})

const mapDispatchToProps = dispatch => ({
  onAddressSelect: address => {
    dispatch(geocodeAddress(address))

    // Manually trigger form's CHANGE event
    // TODO This is not very nice
    dispatch(change('addressLeadForm', 'address', address))
  },
  onSubmit: values => {
    if (activeYears.indexOf(values.year) !== -1) {
      let head

      if (skipLeadCreate) {
        // Save values locally but do not submit
        dispatch(createLeadSuccess(values))

        // Dummy promise to kickstart thenable chain below, if we skip leads
        head = Promise.resolve(42)
      } else {
        head = dispatch(createLead(values))
      }

      head.then(() => dispatch(fetchPositionsAndRedirect()))
    } else if (futureYears.indexOf(values.year) !== -1) {
      dispatch(createLeadSuccess(values)) // Skip submit to API for now
      dispatch(push(`/future_election/${values.year}`))
    } else {
      console.error(`Unknown election year: ${values.year}`)
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)



// WEBPACK FOOTER //
// ./src/components/HomeScene/AddressLeadForm/addressLeadFormContainer.js